import React, { useState, useEffect, useRef } from 'react';
import { dataLayerPush } from '../helpers/analytics';

// Example widget JS function (simulates the widget rendering)
function loadWidget(id, containerRef) {
    
  if (containerRef.current) {
    console.log('open it');
    containerRef.current.innerHTML = `<div class="cf_bcl_wc" data-label-id="${id}"></div>`;
    // Insert your JS widget logic here that uses the passed `id`.
    // For example, it could be something like: widgetLibrary.renderWidget(id, containerRef.current);
  }
}

const BroadbandFacts = ({ id, label }) => {
  const [isOpen, setIsOpen] = useState(false); // Toggle for dropdown
  const widgetRef = useRef(null); // Reference to the widget div
  //const [isMobile, setIsMobile] = useState(false); // To track if it's mobile
  //const [deviceWidth, setDeviceWidth] = useState(window.innerWidth); // Set initial width

  // Function to check the device width and determine if it's mobile
  const checkDeviceWidth = () => {
    const width = window.innerWidth;
    //setDeviceWidth(width);
    if (width <= 767) { 
      //setIsMobile(true);
      setIsOpen(false);
    } /*else {
      setIsMobile(false);
    }*/
  };

  
  useEffect(() => {
    checkDeviceWidth(); 
    
   // window.addEventListener('resize', checkDeviceWidth);

    /*return () => {
      window.removeEventListener('resize', checkDeviceWidth);
    };*/
  }, []);
  
  // Load the widget when the component mounts or when the id changes
  useEffect(() => {
    if (isOpen) {
        window.BroadbandLabelWidget.renderAll();
        console.log('o');
        dataLayerPush({
          'event' : 'broadband-facts',
          'fact_id' : id,
        });
      //loadWidget(id, widgetRef);
    }
  }, [id, isOpen]);

  // Toggle the dropdown state
  const toggleDropdown = () => {
    setIsOpen(prev => !prev);
  };

  //Avoid trigger parent click on child click
  const stopClickPropagation = (event) => {
    event.stopPropagation();
  };

  return (
    <div className='mt-auto'>
      {/* Header section with label and caret */}

      <button type="button" onClick={toggleDropdown} className="btn-bbf-view"><span>More Information</span></button>

      {/* Expandable widget content */}
      <div style={{ height: isOpen ? '100%' : '0', overflow: 'hidden', transition: 'max-height 0.3s ease', textAlign: 'left', position: 'relative' }} >
        <div style={{position: 'fixed', top: '0', paddingTop: isOpen ? '5%' : 0, left: '0', width: '100%', height: isOpen ? '100%' : 0, overflow: isOpen ? 'scroll' : 'hidden', background: '#808080c2', zIndex: '99'}} onClick={toggleDropdown} >
          <div className='resetAll' onClick={stopClickPropagation} >
            <button type="button" class="btn-bbf-close" onClick={toggleDropdown}>X</button>
            <div className="cf_bcl_wc" data-label-id={id}>
              {}
            </div>
        </div>
       </div>
      </div>
    </div>
  );
};

export default BroadbandFacts;
